import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/cartContext';

function CustomDrawer({ isOpen, onClose, hasToken, roles, handleLogout, cartItems, setShowDropdown, showDropdown }) {
  const navigate = useNavigate()
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="drawer-backdrop"
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1040,
        }}
      />

      {/* Drawer */}
      <div
        className="custom-drawer"
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: '300px',
          height: '100vh',
          backgroundColor: '#fff',
          zIndex: 1050,
          boxShadow: '-2px 0 5px rgba(0,0,0,0.2)',
          // padding: '1rem',
          transition: 'transform 0.3s ease-in-out',
        }}
      >
        <div style={{padding: "5px 20px"}}
        className="d-flex justify-content-between align-items-center mb-3 custom-border-bottom">
          {/* <h5>Menu</h5>  */}
          <div>
            <img width={60} src="static/img/logo.png" alt="" srcset="" />
          </div>
          <div>
          <button onClick={onClose} className="btn-close" />
          </div>
        </div>

        <ul className="list-unstyled">
          <li className="pt-2 pb-2 custom-border-bottom custom-hover">
            <Link style={{ color:"#666666", padding: "5px 20px",fontWeight:"400", fontSize: "medium" }} 
            to="/contact" onClick={onClose}>
              
              Message Us
            </Link>
          </li>
          <li className="pt-2 pb-2 custom-border-bottom custom-hover">
            <Link style={{ color:"#666666", padding: "5px 20px",fontWeight: "400", fontSize: "medium" }}
            to="/career" onClick={onClose}>
              Career
            </Link>
          </li>
          <li className="pt-2 pb-2 custom-border-bottom custom-hover">
            <Link to="/cart" style={{ color:"#666666", padding: "5px 20px",fontWeight: "400", fontSize: "medium" }}
            
            onClick={onClose} 
            // className="d-flex align-items-center gap-2">
            >
              Cart
              {cartItems.length > 0 && (
                <span className="badge bg-danger rounded-circle">
                  {cartItems.length}
                </span>
              )}
            </Link>
          </li>
          {!hasToken || roles !== 'User' ? (
            <li className="mb-2 p-3">
              <button className='btn btn-md circle w-100 animation mt-20'
    onClick={() => {
      onClose();
      navigate('/user-login');
    }}
    
  >
    Login
  </button>
            </li>
          ) : (
            <li className="mb-2" style={{ position: 'relative' }}>
              <img
                src="/avtar.jpg"
                alt="Profile"
                style={{ width: 40, height: 40, borderRadius: '50%', cursor: 'pointer' }}
                onClick={() => setShowDropdown((prev) => !prev)}
              />
              {showDropdown && (
                <div
                  style={{
                    position: 'absolute',
                    top: '50px',
                    right: 0,
                    backgroundColor: '#fff',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    borderRadius: '5px',
                    zIndex: 10,
                  }}
                >
                  <button className='btn btn-md circle w-100 animation mt-20'
                    onClick={() => {
                      handleLogout();
                      onClose();
                    }}
                  >
                    Logout
                  </button>
                </div>
              )}
            </li>
          )}
        </ul>
      </div>
    </>
  );
}


function AboutNavBar() {
  const refElement = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [menuOpen, setMenuOpen] = useState(false);
  const [iconOpen, setIconOpen] = useState(false);
  const [showMobileDropdown, setShowMobileDropdown] = useState(false);
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const [hasToken, setHasToken] = useState(false);
  const [showDropdown2, setShowDropdown] = useState(false);
  const [userData, setUserData] = useState(null);
  const [roles, setRoles] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    const userType = localStorage.getItem("userType");
    setUserData(JSON.parse(user));
    setRoles(userType);
    setHasToken(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    setHasToken(false);
    setShowDropdown(false);
    setTimeout(() => {
      navigate("/user-login");
    }, 100);
  };

  useEffect(() => {
    if (refElement.current) {
      refElement.current.style.display = 'none';
    }

    const handleResize = () => {
      const mobile = window.innerWidth <= 991;
      setIsMobile(mobile);
      if (!mobile) {
        setMenuOpen(false);
        setIconOpen(false);
        setShowMobileDropdown(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const showDropdown = () => {
    if (refElement.current && !isMobile) {
      refElement.current.style.display = 'block';
    }
  };

  const hideDropdown = () => {
    if (refElement.current && !isMobile) {
      refElement.current.style.display = 'none';
    }
  };

  const handleToggleClick = () => {
    if (!isMobile) return;
    const navbar = document.querySelector('.navbar');
    const overlay = document.querySelector('.overlay-screen');
    const navbarCollapse = document.querySelector('.navbar-collapse');
    const header = document.querySelector('header');

    const isOpen = menuOpen;

    setMenuOpen(!isOpen);
    setIconOpen(!isOpen);

    navbar?.classList.toggle('navbar-responsive', !isOpen);
    navbar?.classList.toggle('force-sticky', !isOpen);
    overlay?.classList.toggle('opened', !isOpen);
    header?.classList.toggle('adjust-height', !isOpen);
    navbarCollapse?.classList.toggle('show', !isOpen);
    navbarCollapse?.classList.toggle('collapse-mobile', !isOpen);
  };

  return (
    <div>
      <header>
        <nav className="navbar mobile-sidenav navbar-common navbar-default validnavs dark">
          <div className="container">
            <div className="d-flex justify-content-between align-items-center">
              <div className="navbar-header">
                <button type="button" className="navbar-toggle" onClick={handleToggleClick}>
                  <i className={`fa ${iconOpen ? 'fa-times' : 'fa-bars'}`} style={{ display: "inline-block", fontStyle: "normal", fontWeight: "900" }} />
                </button>
                <Link className="navbar-brand" to="/">
                  <img title='Microcode Software' src="/static/img/logo.png" className="logo" alt="Logo" />
                </Link>
              </div>

              <div className="collapse navbar-collapse" id="navbar-menu">
                <div className="collapse-header">
                  <img title='Microcode Software' src="static/img/logo.png" alt="Logo" />
                  <button type="button" className="navbar-toggle" onClick={handleToggleClick}>
                    <i className="fa fa-times" style={{ display: "inline-block", fontStyle: "normal", fontWeight: "900" }} />
                  </button>
                </div>
                <ul className="nav navbar-nav navbar-center" data-in="fadeInDown" data-out="fadeOutUp">
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                  <li className="dropdown" onMouseEnter={() => !isMobile && showDropdown()} onMouseLeave={() => !isMobile && hideDropdown()}>
                    <Link to="#" onClick={(e) => isMobile && (e.preventDefault(), setShowMobileDropdown(!showMobileDropdown))}>
                      Our Services
                    </Link>
                    <ul
                      ref={refElement}
                      className="dropdown-menu"
                      style={{ display: isMobile ? (showMobileDropdown ? 'block' : 'none') : undefined }}
                    >
                      <li><Link to="/application-development">Application Development</Link></li>
                      <li><Link to="/social-media-marketing">Social Media Marketing</Link></li>
                      <li><Link to="/performance-marketing">Performance Marketing</Link></li>
                      <li><Link to="/software-development">Software Development</Link></li>
                      <li><Link to="/website-development">Website Development</Link></li>
                      <li><Link to="/shopify-development">Shopify Development</Link></li>
                      <li><Link to="/seo-services">Search Engine Optimization (SEO)</Link></li>
                    </ul>
                  </li>
                  <li><Link to="/blog">Blog</Link></li>
                  <li><Link to="/contact">contact Us</Link></li>
                  {isMobile && (
                    <>
                      <li><Link to="/contact">Message Us</Link></li>
                      <li><Link to="/cart">Cart</Link></li>
                      {!hasToken || roles !== "User" ? (
                        <li><Link to="/user-login" onClick={() => localStorage.clear()}>Login</Link></li>
                      ) : (
                        <li>
                          <Link onClick={handleLogout} style={{
                            padding: "10px 20px", background: "none", border: "none",
                            width: "100%", textAlign: "left", cursor: "pointer",
                          }}>
                            Logout
                          </Link>
                        </li>
                      )}
                    </>
                  )}
                </ul>
              </div>

              {/* Drawer Toggle Icon */}
              <div className="attr-right">
                <div
                  role="button"
                  style={{
                    cursor: 'pointer',
                    fontSize: '28px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  onClick={() => setDrawerOpen(true)}
                >
                  <i className="fa-solid fa-bars" style={{ color: "black" }} />
                </div>
              </div>

              <div className="attr-right d-block d-sm-block d-lg-none">
                <div className="attr-nav">
                  <ul>
                    <li className="contact d-block d-sm-block d-lg-none">
                      <div className="call">
                        <a href="mailto:contact@microcode.email">
                          <div className="icon">
                            <i className="fas fa-comments-alt-dollar" />
                          </div>
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="overlay-screen" onClick={handleToggleClick} />
        </nav>
      </header>

      {/* Custom Drawer */}
      <CustomDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        hasToken={hasToken}
        roles={roles}
        cartItems={cartItems}
        handleLogout={handleLogout}
        showDropdown2={showDropdown2}
        setShowDropdown={setShowDropdown}
      />
    </div>
  );
}

export default AboutNavBar;
